import { Close } from '@mui/icons-material'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material'
import { FilterModalProps } from 'components/filter-modal/model/filter'

const FilterModal = ({
  title,
  isOpenDialog,
  onCloseDialog,
  count,
  children,
}: FilterModalProps) => (
  <Dialog
    id={`filter-modal-${count}`}
    open={isOpenDialog}
    onClose={onCloseDialog}
  >
    <DialogTitle
      style={{
        margin: '0px',
        paddingLeft: '25px',
        backgroundColor: '#EDF0F4',
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '18px',
          display: 'inline-flex',
          gap: 1,
        }}
      >
        {title}
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '18px',
          }}
        >
          {`(${count >= 0 ? count : 0} seleccionados)`}
        </Typography>
      </Typography>
    </DialogTitle>
    <IconButton
      aria-label="delete"
      onClick={onCloseDialog}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
        '&:hover': {
          backgroundColor: 'white',
        },
      }}
    >
      <Close />
    </IconButton>
    <DialogContent
      style={{
        width: '368px',
        height: '30%',
        borderSpacing: 2,
      }}
    >
      {children}
    </DialogContent>
  </Dialog>
)

export default FilterModal
